import useTheme from "../../../hook/useTheme";
import useNavCollapse, { NAV_EXPANDIDO, NAV_RAIL } from "../../../hook/useNavCollapse";
import useDensidad, { DENSIDAD_COMPACTA, DENSIDAD_NORMAL } from "../../../hook/usePreferenciasUI";
import { THEME_OPTIONS } from "../../Navbars/ThemeSelector";
import { SeccionAjustes, FilaAjuste, Segmentos } from "../../UI/Configuracion/PanelConfiguracion";

/* ============================================================================
   SISTEMA-DE-DISENO · Configuración > Apariencia.

   Tres ajustes, los tres POR USUARIO: no se guardan en el servidor, no viajan
   entre personas y no cambian ningún dato de la clínica. Por eso van en su
   propio grupo, etiquetado.

   El tema ya se podía cambiar desde el menú de usuario. Aquí no se duplica la
   lógica: se reutiliza el mismo contrato (`useTheme` y las mismas opciones
   persistidas en `smartmedic.theme`), sólo que presentado como una fila de
   ajuste. Cambiar el tema en un sitio lo cambia en el otro.
   ========================================================================== */

const OPCIONES_NAV = [
    { value: NAV_EXPANDIDO, label: "Expandido", hint: "Se ven los nombres de cada sección" },
    { value: NAV_RAIL, label: "Sólo iconos", hint: "Deja más ancho para el contenido" },
];

const OPCIONES_DENSIDAD = [
    { value: DENSIDAD_NORMAL, label: "Normal", hint: "Filas altas, más fáciles de seguir" },
    { value: DENSIDAD_COMPACTA, label: "Compacta", hint: "Caben más filas en pantalla" },
];

export default function Apariencia() {
    const { themePreference, setTheme } = useTheme();
    const { preferencia: navPreferencia, alternarNav, esRail } = useNavCollapse();
    const { densidad, setDensidad } = useDensidad();

    return (
        <SeccionAjustes
            titulo="Apariencia"
            alcance="Afecta sólo a tu cuenta"
            descripcion="Se guarda en este navegador. Nadie más ve estos cambios y ningún dato de la clínica se modifica."
        >
            <FilaAjuste
                nombre="Tema"
                explicacion="El mismo que puedes cambiar desde tu menú de usuario. «Automático» sigue la apariencia de tu dispositivo."
            >
                <Segmentos
                    etiqueta="Tema"
                    opciones={THEME_OPTIONS.map(({ value, label, hint }) => ({ value, label, hint }))}
                    valor={themePreference}
                    onCambiar={setTheme}
                />
            </FilaAjuste>

            <FilaAjuste
                nombre="Menú lateral"
                explicacion="En pantallas estrechas el menú se contrae solo, sin tocar esta preferencia."
            >
                <Segmentos
                    etiqueta="Menú lateral"
                    opciones={OPCIONES_NAV}
                    valor={navPreferencia}
                    // `alternarNav` es lo que ya usa el botón de la barra
                    // superior: aquí no se inventa otro camino para lo mismo.
                    onCambiar={(v) => {
                        if (v !== navPreferencia) alternarNav();
                    }}
                />
            </FilaAjuste>

            <FilaAjuste
                nombre="Densidad de tablas"
                explicacion={
                    esRail
                        ? "Con el menú contraído cabe aún más información por fila."
                        : "Cambia la altura de las filas en todos los listados del sistema."
                }
            >
                <Segmentos
                    etiqueta="Densidad de tablas"
                    opciones={OPCIONES_DENSIDAD}
                    valor={densidad}
                    onCambiar={setDensidad}
                />
            </FilaAjuste>
        </SeccionAjustes>
    );
}
